import { z } from 'zod';
import { ChooseTierInput, SubscriptionView, TemplateView, UpgradeRequestInput, UpgradeRequestView, } from '../../subscription.js';
export const subscriptionRoutes = {
    get: { method: 'GET', path: '/me/subscription', response: SubscriptionView },
    choose: {
        method: 'POST',
        path: '/me/subscription',
        body: ChooseTierInput,
        response: SubscriptionView,
    },
    cancel: { method: 'DELETE', path: '/me/subscription', response: SubscriptionView },
    requestUpgrade: {
        method: 'POST',
        path: '/me/upgrade-requests',
        body: UpgradeRequestInput,
        response: UpgradeRequestView,
    },
    myRequests: {
        method: 'GET',
        path: '/me/upgrade-requests',
        response: z.array(UpgradeRequestView),
    },
    templates: { method: 'GET', path: '/me/templates', response: z.array(TemplateView) },
    selectTemplate: {
        method: 'POST',
        path: '/me/templates/:templateId/select',
        response: TemplateView,
    },
};
//# sourceMappingURL=routes.js.map